/**
 * Usage:
 * in your main index.html file (or wherever you want to put your portal destination)
 * <body>
 *   <div id="vue-root"></div>
 *   <div id="portal-root"></div>
 * </body>
 *
 * #vue-root is the root where the vue app is mounted
 * #portal-root is the dom node where your portal will be rendered, it can also be inside your vue root
 *
 * then inside any component you can use this directive like this:
 * <div class="my-inner-node" v-portal="'#portal-root'"></div>
 *
 * inside that v-portal you have to pass a string with a CSS query selector (you can also use a variable inside of your component that resolves to a string)
 *
 * then, this directive will move .my-inner-node inside #portal-root
 */

import Vue from 'vue'

function validateSelector (selector) {
  if (!selector || typeof selector !== 'string') {
    throw new Error(`[v-portal] invalid selector ${selector}. It must be a non-empty string`)
  }
  const root = document.querySelector(selector)
  if (!root) {
    throw new Error(`[v-portal] dom node not found for selector ${selector}`)
  }
  return root
}

// this directive is useful for moving elements deep in the app tree to the bottom of the DOM
// useful for things like modal popups and PDF modals
const Portal = Vue.directive('portal', {
  inserted: (el, binding) => {
    const selector = binding.value
    const root = validateSelector(selector)
    if (root) {
      root.appendChild(el)
    }
  },
  componentUpdated: (el, binding) => {
    const root = validateSelector(binding.value)
    if (!root.contains(el)) {
      root.appendChild(el)
    }
  },
  unbind (el) {
    el.remove()
  }
})

export default Portal
